import React, { Component } from 'react';
import { Button, Col, Input, message, Row, Table } from 'antd';
import moment from 'moment';
import { queryCustom } from '@api/xxcrm/order';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      total: 0,
      data: [],
      isLoading: false,
      pageNo: 1,
    };
  }

  handleChange = e => {
    this.setState({
      name: e.target.value.replace(/\s+/g, ''),
    });
  };

  search = () => {
    this.name = this.state.name;
    this.loadDate();
  };

  componentWillMount() {}

  /**
   * 获取客户列表
   */
  loadDate = pageNo => {
    this.name = this.state.name;
    const params = {};
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      isLoading: true,
      pageNo: current,
    });
    params.limit = 15;
    params.start = current;
    params.name = this.name;

    queryCustom(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  goBack = () => {
    this.props.router.go(-1);
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '联系人名称',
        dataIndex: 'contactName',
        key: 'contactName',
      },
      {
        title: '职位',
        dataIndex: 'contactPosition',
        key: 'contactPosition',
      },
      {
        title: '电话',
        dataIndex: 'contactPhone',
        key: 'contactPhone',
      },
      {
        title: '手机',
        dataIndex: 'contactMobile',
        key: 'contactMobile',
      },
      {
        title: 'qq',
        dataIndex: 'contactQq',
        key: 'contactQq',
      },
      {
        title: '创建时间',
        dataIndex: 'cdate',
        key: 'cdate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '客户等级',
        dataIndex: 'level',
        key: 'level',
        render: text => {
          let levelName = '';
          switch (text) {
            case 0:
              levelName = '初步接触';
              break;
            case 1:
              levelName = '深入了解';
              break;
            case 2:
              levelName = '考虑购买';
              break;
            default:
              break;
          }
          return <span>{levelName}</span>;
        },
      },
    ];
  };

  render() {
    const { total, isLoading } = this.state;
    const pagination = {
      total,
      showSizeChanger: false,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const { data } = this.state;
    return (
      <div className="protect-sql">
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Row
              type="flex"
              className="protect_search"
              justify="end"
              style={{ marginBottom: '16px' }}
            >
              <Col>
                <Input
                  placeholder="请输入客户名称"
                  style={{ width: '300px' }}
                  onChange={this.handleChange}
                  onPressEnter={this.search}
                  value={this.state.name}
                />
                <Button type="primary" onClick={this.search} style={{ marginLeft: '10px' }}>
                  搜索
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Table
          rowKey="uuid"
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/xianxing/custom/Index.js